import { SegmentEvents, analytics } from './analytics'

const FEATURE_STORAGE_KEY = 'features'

const getFeatureUsage = () => {
  const raw = localStorage.getItem(FEATURE_STORAGE_KEY)

  return raw ? JSON.parse(raw) : {}
}

const setFeatureUsage = (data: Record<string, string>) => {
  localStorage.setItem(FEATURE_STORAGE_KEY, JSON.stringify(data))
}

export const trackFeatureUsage = (
  featureName: TrackedFeatures,
  creatorId?: number | null,
) => {
  const usage = getFeatureUsage()
  const now = new Date()
  const key = `${featureName}${creatorId ? `-${creatorId}` : ''}`
  const lastUsed = usage[key] ? new Date(usage[key]) : null

  const dayAgo = new Date()

  dayAgo.setDate(dayAgo.getDate() - 1)

  // daily tracking to avoid spamming
  if (!lastUsed || lastUsed < dayAgo) {
    analytics.track(SegmentEvents.FeatureUsed, {
      featureName,
      creatorId: creatorId ? String(creatorId) : undefined,
    })

    usage[key] = now.toISOString()
    setFeatureUsage(usage)
  }
}

export enum TrackedFeatures {
  OnlineMassMessaging = 'omm',
  FanInfo = 'fan-info',
  CUIMessaging = 'cui-messaging',
  AutoWelcomeMessages = 'auto-welcome-messages',
  AutoFollowUpMessages = 'auto-follow-up-messages',
  ExpiringFans = 'expiring-fans',
  RebillMessages = 'rebill-messages',
  ChatterTracking = 'chatter-tracking',
  TiktokStatistics = 'tiktok-stats',
  InstagramStatistics = 'instagram-stats',
  AiTranslatorMessaging = 'ai-translator-messaging',
  PpvOverview = 'ppv-overview',
  Tasks = 'tasks',
  OldOFLauncher = 'of-browser',
  Prospects = 'prospects',
  Accounting = 'accounting',
  CUICollections = 'cui-collections',
  CustomLists = 'custom-lists',
  HelpDesk = 'help-desk',
  Shifts = 'shifts',
  TiktokResearch = 'tiktok-research',
  CreatorInfo = 'creator-info',
}
